import { combineReducers } from 'redux';

import nonUsFinancialAccountsReducer from './NonUSFinancialAccounts/slice';
import accountsListReducer from './AccountsList/slice';

export default combineReducers({
  nonUsFinancialAccounts: nonUsFinancialAccountsReducer,
  accountsList: accountsListReducer,
});
